export const getBaseUrl = () => {
	if (typeof window !== "undefined") {
		// Browser
		return window.location.origin;
	}
	if (process.env.NODE_ENV === "development") {
		return "https://localhost:3000";
	}

	if (process.env.VERCEL_ENV === "preview") {
		return `https://${process.env.VERCEL_BRANCH_URL}`;
	}

	if (process.env.VERCEL_PROJECT_PRODUCTION_URL) {
		return `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`;
	}

	return "http://localhost:3000";
};
